import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, IntlShape } from 'react-intl';
import Text from '../../../../global/text/text';
import { MultiSelectButton } from '../../../../global/multi-select/multi-select-button';
import MultiSelectWithRoleHeader from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-header';
import { MultiSelectWithRoleList } from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-list';
import { OperatorsList } from '../../shared/operators-list/operators-list';
import { getFormattedOperatorRoles } from '../../../../../constants/entity-role-with-intl';
import { OperatorsBulkUpdateFormViewModel } from './operators-bulk-update-form.viewmodel';
import { addText, cancelText } from '../../../../../constants/common-labels.constants';

interface IProps {
    formVM: OperatorsBulkUpdateFormViewModel;
    intl: IntlShape;
}

const OperatorsBulkUpdateFormBodyPresentation = observer((props: IProps) => {
    const { formVM, intl } = props;
    const {
        initOperatorsData,
        onOperatorRoleChange,
        operators,
        removeOperatorByEmail,
        operatorsToAdd,
        setOperators,
    } = formVM;

    const operatorRoles = getFormattedOperatorRoles(intl);
    const disabledOperators = operatorsToAdd.concat(formVM.operatorsToRemove);

    return (
        <form className='oe-form'>
            <div className='oe-form__body'>
                <div className='attendee-list'>
                    <div className='attendee-list__label m-bottom-4px'>
                        <Text
                            id='oe.common.operators'
                            description='Label text'
                            message='Operators'
                            />
                    </div>
                    <MultiSelectButton
                        className='attendee-list__add-button m-bottom-8px'
                        popoverClassName='multi-select-with-role event_form__items-section m-bottom-0px'
                        items={operators}
                        value={operatorsToAdd}
                        disabled={disabledOperators}
                        keyProperty='email'
                        nameProperty='fullName'
                        filterHandler={initOperatorsData}
                        searchWithDebounce
                        onChange={setOperators}
                        text={<FormattedMessage
                            id='oe.operators.add'
                            description='Button text'
                            defaultMessage='{prefix} Add Operators'
                            values={{prefix: '+'}}
                        />}
                        renderHeader={MultiSelectWithRoleHeader}
                        renderSelectList={rest =>
                            <MultiSelectWithRoleList
                                entityRoleKey='operatorRole'
                                intlRoleKey='operators.roleOptions'
                                entityRolesList={operatorRoles}
                                intl={intl}
                                {...rest}
                            />
                        }
                        applyButtonText={addText()}
                        resetButtonText={cancelText()}
                        onClick={formVM.initOperatorsData}
                    />
                    {!!operatorsToAdd.length &&
                        <OperatorsList
                            withCloseIcone
                            operators={operatorsToAdd}
                            onOperatorRoleChange={onOperatorRoleChange}
                            removeOperator={removeOperatorByEmail}
                        />
                    }

                    <MultiSelectButton
                        className='operator-list__remove-button m-bottom-8px m-top-30px'
                        items={formVM.meetingsAssignedOperators}
                        value={formVM.operatorsToRemove}
                        disabled={disabledOperators}
                        keyProperty='email'
                        nameProperty='fullName'
                        filterHandler={formVM.searchOperatorsInMeetings}
                        searchWithDebounce
                        onChange={formVM.setOperatorsToRemove}
                        text={<FormattedMessage
                            id='oe.operators.remove'
                            description='Button text'
                            defaultMessage='{prefix} Remove Operators'
                            values={{ prefix: '-' }}
                        />}
                        applyButtonText={addText()}
                        resetButtonText={cancelText()}
                        onClick={formVM.initMeetingsOperatorsData}
                    />
                    {!!formVM.operatorsToRemove.length &&
                        <OperatorsList
                            classname='operators-remove-list'
                            withCloseIcone
                            operators={formVM.operatorsToRemove}
                            removeOperator={formVM.removeOperatorFromRemoveList}
                        />
                    }
                </div>
            </div>
        </form>
    );
});

export default OperatorsBulkUpdateFormBodyPresentation;
